/* jslint esversion: 6 */
/**
 * Carbon Theme Scripts (theme.js)
 *
 * @todo migrate legacy modules
 *
 * ./theme/canvas-color-bars.js'),
 * ./theme/categories-list-collapse.js'), // requires styles
 * ./theme/post-content-expand.js'),
 * ./theme/faqs-toggle.js'),
 * ./theme/footer-return.js'),
 * ./theme/gallery-slides.js'),
 * ./theme/header-search.js'),
 * ./theme/jquery.fresco.js'),
 * ./theme/jquery.jvectormap.js'),
 * ./theme/slides.js'),
 * ./theme/tooltips.js'), // requires styles
 * ./theme/widget-archive-by-year.js'), // requires styles
 * ./theme/jquery.magnific-popup.js'), // requires styles
 * ./theme/select-classes.js'),
 * ./theme/slides--hero.js'),
 */

// window.magnificPopup = require('./vendor/jquery.magnific-popup-1.0.1.min.js'); // require doesnt work
// window.swipebox = require('./../../node_modules/swipebox/src/js/jquery.swipebox.min.js'); // @see https://github.com/brutaldesign/swipebox/pull/324
window.swipebox = require('./vendor/jquery.swipebox-1.4.4.modified.js');

import debug               from './theme/debug';
import faviconBadge        from './theme/favicon-badge';

import menuHeader          from './theme/menu--header';
import menuMobile          from './theme/menu--mobile';
import menuSectionAttorney from './theme/menu--section--attorney';
import headerFixed         from './theme/header-fixed'; // requires styles
import secondaryFixed      from './theme/secondary-fixed'; // requires styles

import scrollThrottle                                       from './theme/scroll-throttle';
import scrollTransition, {scroll as scrollTransitionScroll} from './theme/scroll-transition';

import maxWidthNarrativeContent from './theme/max-width-narrative-content';
import maxWidthIFrame           from './theme/max-width-iframe'; // requires styles
import maxWidthTable            from './theme/max-width-table'; // requires styles
import swipebox                 from './theme/swipebox'; // requires styles

// import debounce         from './theme/debounce';
// import googleMaps       from './theme/google-maps';
// import googleTranslate  from './theme/google-translate';
// import modal            from './theme/modal'; // requires styles // @fixme remove for production
// import photoswipe       from './theme/photoswipe'; // requires styles
// import resizeThrottle   from './theme/resize-throttle';

import {all as equalizeWidth}     from './theme/equalize-width';
import {top as equalizeHeightTop} from './theme/equalize-height';
// import {all as equalizeHeightAll} from './theme/equalize-height';

const $ = window.jQuery;

// Vanilla JS version of $(document).ready() works in IE9+
document.addEventListener('DOMContentLoaded', function() {

	debug();
	faviconBadge();

	menuHeader();
	menuMobile();
	menuSectionAttorney();
	headerFixed();
	secondaryFixed();
	maxWidthIFrame();
	maxWidthTable();
	scrollThrottle();
	scrollTransition();

	$('.post-filter select').on('change', function() {
		window.location = this.value;
	});

	$('.post-filters-toggle a').on('click', function(event) { event.preventDefault();
		$(this).toggleClass('active').blur();
		$('.post-filters').toggleClass('active');
	});

	$('.attorney-filters-toggle a').on('click', function(event) { event.preventDefault();
		$(this).toggleClass('active').blur();
		$('.attorney-filters').toggleClass('active');
	});

	/** offset blockquote with leading quote */
	// $('blockquote').each(function() {
	// 	var letter = $(this).children(':first-child').text().substr(0, 1);
	//
	// 	if (letter === '"' || letter === '“') {
	// 		$(this).addClass('blockquote--has-quote');
	// 	}
	// });

	// scroll to top for Attorney's Archive pagination
	$('body').on('click', '.facetwp-page', function () {
		scrollTransitionScroll('.js-attorney-filters');
	});

	$(window).on('load resize facetwp-loaded', function() {

		/** equalize width */
		equalizeWidth('.archive-attorney__brief');

		/** equalize height */
		equalizeHeightTop('.archive-industry__heading', 600); // @fixme match $breakpoint--archive-post-group__flex-width-2
		equalizeHeightTop('.archive-practice__heading', 600); // @fixme match $breakpoint--archive-post-group__flex-width-2
	});
});
